import apiSlice from "../../app/api/apiSlice";

export const brandingApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getCompanyBranding: builder.query({
			query: (companyId) => `/api/company/${companyId}/branding`,
			providesTags: [{ type: "Branding", id: "LIST" }],
		}),
		updateCompanyBranding: builder.mutation({
			query: ({ companyId, formData }) => ({
				url: `/api/company/${companyId}/branding`,
				method: "POST",
				body: formData,
			}),
			invalidatesTags: [{ type: "Branding", id: "LIST" }],
		}),
		removeImageFromCompanyBranding: builder.mutation({
			query: ({ companyId, formData }) => ({
				url: `/api/company/${companyId}/branding/image`,
				method: "POST",
				body: formData,
			}),
			invalidatesTags: [{ type: "Branding", id: "LIST" }],
		}),
		getCurrentBranding: builder.query({
			query: () => `/api/branding`,
			providesTags: [{ type: "Branding", id: "LIST" }],
		}),
	}),
	overrideExisting: true,
});

export const {
	useGetCompanyBrandingQuery,
	useUpdateCompanyBrandingMutation,
	useRemoveImageFromCompanyBrandingMutation,
	useGetCurrentBrandingQuery,
} = brandingApiSlice;
